import { handleActions } from 'redux-actions';
import {
} from 'lodash';

import {
  INITIALIZE_FAILURE, INITIALIZE_REQUEST, INITIALIZE_SUCCESS,
  PATCH_REQUEST, PATCH_SUCCESS, PATCH_FAILURE,
  DELETE_REQUEST, DELETE_SUCCESS, DELETE_FAILURE,
  POST_REQUEST, POST_SUCCESS, POST_FAILURE, POST_OUT_OF_RANGE_SUCCESS,
  SET_PERIOD,
  FETCH_ENTRIES_FAILURE, FETCH_ENTRIES_REQUEST, FETCH_ENTRIES_SUCCESS,
  PUNCH_FAILURE, PUNCH_REQUEST, PUNCH_SUCCESS,
  OPEN_ENTRY_FAILURE, OPEN_ENTRY_REQUEST, OPEN_ENTRY_SUCCESS,
} from './constants';

const initialState = {
  teamOverview: {
    openEntry: {},
    openEntryFetched: false,
    openEntryFetching: false,
    openEntryError: false,
    openEntryErrorMessage: '',
    isPunching: false,
    isPunchedIn: false,
    punchError: false,
    punchErrorMessage: '',
    fetchingEntries: false,
    fetchedEntries: false,
    workingHours: [],
    entries: {},
    loading: {},
    error: '',
    hasError: false,
    start: {},
    end: {},
    initialized: false,
    initializing: false,
    entryTypes: {},
    patching: false,
    patchError: null,
    deleting: false,
    posting: false,
    initializeFailed: false,
    periodFrom: '1',
    hideActions: true,
    workingDays: 0,
    timeEmailTypes: [],
  },
};

export default handleActions({
  [FETCH_ENTRIES_REQUEST]: state => ({
    ...state,
    fetchingEntries: true,
    entries: {},
    error: '',
    hasError: false,
  }),
  [FETCH_ENTRIES_SUCCESS]: (state, { entries }) => ({
    ...state,
    entries,
    fetchedEntries: true,
    fetchingEntries: false,
  }),
  [FETCH_ENTRIES_FAILURE]: (state, action) => ({
    ...state,
    error: action.error,
    hasError: true,
    fetchingEntries: false,
    fetchedEntries: false,
  }),
  [INITIALIZE_REQUEST]: state => ({
    ...state,
    initialized: false,
    initializing: true,
    error: '',
    hasError: false,
    initializeFailed: false,
  }),
  [INITIALIZE_SUCCESS]: (state, {
    entryTypes, periodFrom, workingHours, hideActions, timeEmailTypes
  }) => ({
    ...state,
    initialized: true,
    initializing: false,
    entryTypes,
    periodFrom,
    workingHours,
    initializeFailed: false,
    timeEmailTypes,
    hideActions,
  }),
  [INITIALIZE_FAILURE]: (state, { error }) => ({
    ...state,
    error,
    hasError: true,
    initialized: false,
    initializing: false,
    initializeFailed: true,
  }),
  [PATCH_REQUEST]: state => ({
    ...state,
    patching: true,
  }),
  [PATCH_SUCCESS]: (state, { entry, entryId }) => ({
    ...state,
    patching: false,
    entries: {
      ...state.entries,
      [entryId]: entry,
    },
  }),
  [PATCH_FAILURE]: (state, { error }) => ({
    ...state,
    patchError: error,
    patching: false,
  }),
  [DELETE_REQUEST]: state => ({
    ...state,
    deleting: true,
  }),
  [DELETE_SUCCESS]: (state, { entries }) => ({
    ...state,
    entries: { ...entries },
    deleting: false,
  }),
  [DELETE_FAILURE]: state => ({
    ...state,
    deleting: false,
  }),
  [POST_REQUEST]: state => ({
    ...state,
    posting: true,
  }),
  [POST_SUCCESS]: (state, { entries }) => ({
    ...state,
    entries: {
      ...state.entries,
      ...entries,
    },
    posting: false,
  }),
  [POST_OUT_OF_RANGE_SUCCESS]: state => ({
    ...state,
    posting: false,
  }),
  [POST_FAILURE]: state => ({
    ...state,
    posting: false,
  }),
  [SET_PERIOD]: (state, {
    start, end, datesBetween, workingDays,
  }) => ({
    ...state,
    start,
    end,
    datesBetween,
    workingDays,
  }),
  [PUNCH_REQUEST]: state => ({
    ...state,
    isPunching: true,
  }),
  [PUNCH_SUCCESS]: (state, { openEntry, isPunchedIn }) => ({
    ...state,
    openEntry,
    isPunchedIn,
    isPunching: false,
    punchError: false,
    punchErrorMessage: '',
  }),
  [PUNCH_FAILURE]: (state, { error }) => ({
    ...state,
    isPunching: false,
    punchError: true,
    punchErrorMessage: error,
  }),
  [OPEN_ENTRY_REQUEST]: state => ({
    ...state,
    openEntryFetched: false,
    openEntryFetching: true,
  }),
  [OPEN_ENTRY_SUCCESS]: (state, { openEntry, isPunchedIn }) => ({
    ...state,
    openEntry,
    openEntryFetched: true,
    openEntryFetching: false,
    isPunchedIn,
    openEntryError: false,
    openEntryErrorMessage: '',
  }),
  [OPEN_ENTRY_FAILURE]: (state, { error }) => ({
    ...state,
    openEntryFetched: true,
    openEntryFetching: false,
    openEntryError: true,
    openEntryErrorMessage: error,
  }),
}, initialState.teamOverview);



// WEBPACK FOOTER //
// ./src/sites/time/reducer.js